import React, { useEffect, useMemo, useState } from 'react'
import { Button, Input, Modal, Section } from '../../components'
import { LoginStyled } from './styled'
import { STRING, yup as Yup, trimmedString } from '../../helpers'
import { authController } from '../../apiService'
import { toast } from 'react-toastify'
import { Formik, Form } from 'formik'
import { axios, updateProgress } from '../../apiService/apiService'
import { BASE_API } from '../../apiService/apiConfig'
import { useAuth } from '../../contexts/Auth.context'
import { SupportLink } from '../HomeContainer'

const ForgetPassword = ({ state, setState }) => {
  const { isModalForgotPasswordOpen, isErrForgotPassword } = state

  const funcForgotPassword = async values => {
    const res = await authController().getForgotPassword(values.emailForgot)
    const { data } = res

    if (data && data.status === 'success') {
      setState({
        isModalForgotPasswordOpen: !isModalForgotPasswordOpen,
        submitted: true,
      })
      return toast(data.message, {
        position: 'top-center',
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        type: 'success',
      })
    }
  }

  const _submitForgotPassword = async values => {
    setState({
      ...state,
      submitted: false,
    })

    try {
      await funcForgotPassword(values)
    } catch (error) {
      if (error.message === 'Email is not registered') {
        setState({
          ...state,
          submitted: true,
        })
        return toast('Email is not registered', {
          position: 'top-center',
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          type: 'error',
        })
      } else {
        setState({
          submitted: true,
        })
      }
    }
  }

  const validateForgotFormSchema = () => {
    const schema = Yup.object().shape({
      emailForgot: Yup.string()
        .transform(emailValue => trimmedString(emailValue))
        .required(STRING.INVALID)
        .email(STRING.EMAIL_INVALID),
    })
    if (schema) {
      setState({
        isErrForgotPassword: true,
      })
    }
    return schema
  }

  return (
    <Formik
      initialValues={{
        //กำหนด initialValues
        emailForgot: '',
      }}
      validationSchema={validateForgotFormSchema} //กำหนด validationSchema
      onSubmit={(values, actionProps) => {
        _submitForgotPassword(values)
        actionProps.resetForm()
      }}
      validateOnChange={true}
    >
      {props => {
        return (
          <Form>
            <Section
              className={`forgot-password-form form-group ${
                props.errors.emailForgot && isErrForgotPassword
                  ? 'is-error'
                  : ''
              }`}
            >
              <Input
                id="emailForgot"
                label={STRING.EMAIL_LABEL}
                type="email"
                name="emailForgot"
                value={
                  !isModalForgotPasswordOpen
                    ? (props.values.emailForgot = '')
                    : props.values.emailForgot
                }
                onChange={props.handleChange}
              />
              <Section className="message">
                {props.errors &&
                  isErrForgotPassword &&
                  props.errors.emailForgot}
              </Section>

              <Button
                id="forgot_password_submit"
                className="theme-green"
                onClick={() => props.submitForm()}
              >
                {state.submitted ? (
                  STRING.SUBMIT
                ) : (
                  <span className="loader"></span>
                )}
              </Button>
            </Section>
          </Form>
        )
      }}
    </Formik>
  )
}

const LoginContainer = props => {
  const auth = useAuth()
  const [loading, setLoading] = useState(false)
  const [state, _setState] = useState({
    isModalForgotPasswordOpen: false,
    email: '',
    emailForgot: '',
    password: '',
    emailValid: false,
    emailValidForgot: true,
    passwordValid: false,
    formValid: true,
    formValidForgot: true,
    wrongEmailPassword: false,
    submitted: true,
    versionBackEnd: '',
    isErrForgotPassword: false,
    CheckAutoUpdateIsOn: '',
    auth: {},
  })

  const setState = (newState = {}) => {
    _setState(prevState => ({ ...prevState, ...newState }))
  }

  const abort = new AbortController()

  const getCheckUpdate = async () => {
    const res = await authController().checkAutoUpdate({ signal: abort.signal })
    if (res) {
      setState({ CheckAutoUpdateIsOn: res.is_on })
    }
  }

  const getVersion = async () => {
    const res = await axios.get(`${BASE_API}/version`, { signal: abort.signal })
    if (res) {
      setState({ versionBackEnd: res.data })
    }
  }

  const fetchInit = async () => {
    if (loading) {
      return
    }

    setLoading(true)
    await Promise.all([getVersion(), getCheckUpdate()])
    setLoading(false)
  }

  useEffect(() => {
    updateProgress({ open: false, percent: 0 })

    fetchInit()

    return () => {
      if (abort) {
        setState({})
        setLoading(false)
        abort.abort()
      }
    }
  }, [])

  const toggleModalForgotPassword = e => {
    e.preventDefault()
    setState({
      isModalForgotPasswordOpen: !state.isModalForgotPasswordOpen,
      formValid: true,
      passwordValid: true,
      email: '',
      password: '',
      emailValidForgot: false,
      emailForgot: '',
      formValidForgot: true,
      submitted: true,
      isErrForgotPassword: false,
    })
  }

  const validateLoginFormSchema = () => {
    const schema = Yup.object().shape({
      email: Yup.string()
        .transform(emailValue => trimmedString(emailValue))
        .required(STRING.INVALID)
        .email(STRING.EMAIL_INVALID),
      password: Yup.string()
        .transform(passwordValue => trimmedString(passwordValue))
        .required(STRING.INVALID)
        .min(8, 'minimum 8 characters'),
    })
    return schema
  }

  const RenderVersion = () => (
    <div className="app-version">
      <p>{process.env.VERSION}</p>
      <p>{state.versionBackEnd}</p>
    </div>
  )

  const RenderFormLogin = () => {
    return (
      <Formik
        initialValues={{ email: '', password: '' }}
        validationSchema={validateLoginFormSchema}
        onSubmit={(values, actionProps) => {
          auth.login(values)
          actionProps.resetForm()
        }}
        validateOnChange={false}
      >
        {props => {
          return (
            <Form>
              <Section className="login-wrapper">
                <div className="login-brand">
                  <span className="login-brand-mark" aria-hidden="true">
                    <svg viewBox="0 0 24 24">
                      <path d="M12 2l2.4 4.86L20 7.7l-4 3.9.94 5.4L12 14.5l-4.94 2.5L8 11.6 4 7.7l5.6-.84L12 2z" />
                    </svg>
                  </span>
                  <span className="login-brand-name">
                    ASTRO
                    <span className="login-brand-sub">E-Procurement</span>
                  </span>
                </div>
                <Section className="login-form">
                  <Section
                    className={`form-group ${
                      props.errors.email ? 'is-error' : ''
                    }`}
                  >
                    <Input
                      id="login_email"
                      label={STRING.EMAIL_LABEL}
                      type="email"
                      name="email"
                      value={props.values.email}
                      onChange={props.handleChange}
                    />
                  </Section>
                  <Section className="message">
                    {props.errors && props.errors.email}
                  </Section>
                  <Section
                    className={`form-group ${
                      props.errors.password ? 'is-error' : ''
                    }`}
                  >
                    <Input
                      id="login_password"
                      label={STRING.PWD_LABEL}
                      name="password"
                      type="password"
                      value={props.values.password}
                      onChange={props.handleChange}
                    />
                  </Section>
                  <Section className="message">
                    {props.errors && props.errors.password}
                  </Section>
                  <Button
                    id="forgot_password_link"
                    className="link"
                    onClick={toggleModalForgotPassword}
                  >
                    {STRING.FORGET_PWD}
                  </Button>

                  <Button
                    id="sign_in_button"
                    onClick={() => props.submitForm()}
                    className="theme-blue"
                  >
                    {STRING.SING_IN}
                  </Button>
                </Section>
              </Section>
            </Form>
          )
        }}
      </Formik>
    )
  }

  const CheckAutoUpdate = () => {
    return (
      <div className="update-check">
        <p>Auto update: {state.CheckAutoUpdateIsOn ? 'ON' : 'OFF'}</p>
      </div>
    )
  }

  return useMemo(
    () => (
      <>
        <LoginStyled className="login-page">
          <RenderFormLogin />
          <div className="support-link">
            <SupportLink />
          </div>
          <RenderVersion />
          <CheckAutoUpdate />
        </LoginStyled>

        <Modal
          id="forgot_password"
          className="forgot-password theme-blue"
          isOpen={state.isModalForgotPasswordOpen}
          onClickBackground={toggleModalForgotPassword}
        >
          <Modal.Header>{STRING.FORGET_PWD_TITLE}</Modal.Header>

          <Modal.Body>
            <Section className="caption">
              {STRING.FORGET_YOUR_PWD} <br />
              {STRING.FORGET_PWD_DETAIL}
            </Section>
            <ForgetPassword state={state} setState={setState} />
          </Modal.Body>

          <Modal.Footer />
        </Modal>
      </>
    ),
    [state]
  )
}

export default LoginContainer
